export default __webpack_public_path__ + "static/media/team16.cba8111a.JPG";